export default "__VITE_ASSET__336a5220__"